import { render, staticRenderFns } from "./NfAnalytics.vue?vue&type=template&id=4ffcbd6a"
import script from "./NfAnalytics.vue?vue&type=script&lang=js"
export * from "./NfAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports